document.addEventListener('DOMContentLoaded', function() {
  const drawerContainer = document.getElementById('Details-menu-drawer-container');
  const mainContent = document.querySelector('main');

  if (!drawerContainer) return;

  const observer = new MutationObserver(function() {
    if (window.innerWidth > 749) return;
    
    if (drawerContainer.hasAttribute('open')) {
      if (mainContent) {
        mainContent.style.transform = 'translateX(50vw)';
        mainContent.style.transition = 'transform 0.3s ease';
      }
    } else {
      if (mainContent) {
        mainContent.style.transform = 'translateX(0)';
        mainContent.style.transition = 'transform 0.3s ease';
      }
    }
  });

  observer.observe(drawerContainer, { attributes: true });
});